import DIContainer from '@components/DependencyInjectionContainer.js';
import { CaptionManager } from '@components/CaptionManager/CaptionManager.js';
import { ComponentRegistry } from '@components/ComponentRegistry.js';
import { IconManager } from '@components/IconManager/IconManager.js';
import { Request } from '@components/Request/Request.js';
import { ScreenRouter } from '@components/ScreenRouter/ScreenRouter.js';
import { ContextMenu } from '@components/Component/ContextMenu/ContextMenu.js';
import { ScreenManager_Single } from '@components/Component/Container/ScreenManager/ScreenManager_Single/ScreenManager_Single.js';
import { Alert } from '@components/Component/Container/Modal/DialogModal/Alert/Alert.js';
import { DragManager } from '@components/DragManager/DragManager.js';
import { DataRecord } from '@components/DataRecord/DataRecord.js';
import { RecordLogic } from '@components/RecordLogic/RecordLogic.js';
import { CacheManager } from '@components/CacheManager/CacheManager.js';
import { ErrorForm } from '@components/Component/Container/Form/ErrorForm/ErrorForm.js';
import { ResizeManager } from '@components/ResizeManager/ResizeManager.js';
import { TooltipManager } from '@components/Component/TooltipManager/TooltipManager.js';
import { Tooltip } from '@components/Component/TooltipManager/Tooltip/Tooltip.js';
import { BaseClass } from '@components/BaseClass.js';
import { BroadcastManager } from '@components/BroadcastManager/BroadcastManager.js';
import { Navbar } from '@components/Component/Navbar/Navbar.js';
import { Viewport } from '@components/Component/Viewport/Viewport.js';
import { SessionTimeoutManager } from '@components/SessionTimeoutManager/SessionTimeoutManager.js';
import { ScreenCover } from '@components/Component/Container/Screen/ScreenCover/ScreenCover.js';
import { Panel } from "@components/Component/Container/Panel/Panel.js";
import { PanelSet } from "@components/Component/Container/PanelSet/PanelSet.js";
import { MemoryMonitor } from '@components/Component/MemoryMonitor/MemoryMonitor.js';
import { ToastManager } from '@components/Component/ToastManager/ToastManager.js';
import { Toast } from '@components/Component/ToastManager/Toast/Toast.js';
import { ConnectivityManager } from './components/ConnectivityManager/ConnectivityManager.js';
import { UrlHandler } from '@components/UrlHandler/UrlHandler.js';
// Registering with constructors
DIContainer.register('BaseClass', BaseClass);
DIContainer.register('Alert', Alert);
DIContainer.registerSingleton('CaptionManager', CaptionManager);
DIContainer.register('Tooltip', Tooltip);
DIContainer.register('Toast', Toast);
DIContainer.register('ErrorForm', ErrorForm);
DIContainer.register('DataRecord', DataRecord);
DIContainer.register('Panel', Panel);
DIContainer.register('PanelSet', PanelSet);
DIContainer.registerSingleton('RecordLogic', RecordLogic);
DIContainer.registerSingleton('ComponentRegistry', ComponentRegistry);
DIContainer.registerSingleton('ScreenRouter', ScreenRouter);
DIContainer.registerSingleton('DragManager', DragManager);
DIContainer.registerSingleton('IconManager', IconManager);
DIContainer.registerSingleton('ResizeManager', ResizeManager);
DIContainer.registerSingleton('Request', Request);
DIContainer.registerSingleton('BroadcastManager', BroadcastManager);
DIContainer.registerSingleton('Navbar', Navbar);
DIContainer.registerSingleton('Viewport', Viewport);
DIContainer.registerSingleton('SessionTimeoutManager', SessionTimeoutManager);
DIContainer.registerSingleton('ScreenCover', ScreenCover);
DIContainer.registerSingleton('MemoryMonitor', MemoryMonitor);
DIContainer.registerSingleton('ConnectivityManager', ConnectivityManager);
DIContainer.registerSingleton('UrlHandler', UrlHandler);
// TODO: registering these by constructor would be better for customizability, just need to either rework these slightly to not need these factory functions or maybe pass constructor as an additional param
DIContainer.registerSingleton('TooltipManager', () => {
    const rootElement = document.createElement('div');
    return new TooltipManager('', rootElement);
});
DIContainer.registerSingleton('ToastManager', () => {
    const rootElement = document.createElement('div');
    return new ToastManager('', rootElement);
});
DIContainer.registerSingleton('ContextMenu', () => {
    const root = document.createElement('div');
    const menu = new ContextMenu('contextmenu', root);
    menu.draw();
    return menu;
});
DIContainer.registerSingleton('ScreenManager', () => {
    return DIContainer.getInstance('ScreenManager_Single');
});
DIContainer.registerSingleton('ScreenManager_Single', () => {
    return new ScreenManager_Single('screenmanager', document.createElement('div'));
});
DIContainer.registerSingleton('CacheManager', () => new CacheManager('cache'));
